import { render, staticRenderFns } from "./MultipleChoiceDashboardItem.vue?vue&type=template&id=12e59ea8&scoped=true"
import script from "./MultipleChoiceDashboardItem.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceDashboardItem.vue?vue&type=style&index=0&id=12e59ea8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e59ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e59ea8')) {
      api.createRecord('12e59ea8', component.options)
    } else {
      api.reload('12e59ea8', component.options)
    }
    module.hot.accept("./MultipleChoiceDashboardItem.vue?vue&type=template&id=12e59ea8&scoped=true", function () {
      api.rerender('12e59ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/MultipleChoiceDashboardItem.vue"
export default component.exports